'use strict';

require('fancybox');
require('../../products/CompanyProductsService.js');
require('../../customers/CompanyCustomersService.js');
require('../../CompanyService.js');
var moment = require('moment');

function CompanyPublicationCompanyOrderCtrl(
  $scope,
  $state,
  $stateParams,
  $translate,
  config,
  $q,
  $http,
  $modal,
  $filter,
  growl,
  CompanyProductsService,
  CompanyCustomersService,
  CompanyPublicationService,
  CompanyPublicationCompanyOrderService,
  CompanyPublicationCompanyOrderSubcriptionService,
  CompanyService) {

  $scope.nonProductsAdded = [];
  var nonProdcutAddedPromise;
  $scope.newAddress = null;

  angular.forEach($scope.children, function(value, key){
    if(value.features.currentCompanyOrderId){
      CompanyPublicationCompanyOrderSubcriptionService.get({
        companyId: $stateParams.companyId,
        publicationId: value.id,
        subcriptionId: value.features.currentCompanyOrderId
      }).$promise.then(function(order){
        $scope.children[key].order = order;
        var subcription            = $scope.children[key].order.interval.split(' ');
        $scope.children[key].order.subcriptionNumber   = parseInt(subcription[0]);
        $scope.children[key].order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
        if(!$scope.children[key].order.lastGenAt){
          $scope.children[key].order.lastGenAt = $scope.children[key].order.createdAt;
        }
        if($scope.children[key].order.startAt >= $scope.children[key].order.lastGenAt){
          $scope.children[key].order.nextCreatedOrder = moment($scope.children[key].order.startAt).add(parseInt($scope.children[key].order.subcriptionNumber), $scope.children[key].order.optionSubcription+($scope.children[key].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
        }else{
          $scope.children[key].order.nextCreatedOrder = moment($scope.children[key].order.lastGenAt).add(parseInt($scope.children[key].order.subcriptionNumber), $scope.children[key].order.optionSubcription+($scope.children[key].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
        }
        
        updateTotalOrderChild($scope.children[key]);
        $scope.filterPriceListName();
      });
    }else{
      $scope.children[key].order = false;
    }
  });

  $scope.$on('orderChanged', function (event, data) {
    $scope.order = data;
  });

  setTimeout(function(){
    angular.element('div[g-places-autocomplete-drawer]').css('position', 'initial');
  },1);

  var totalOrderChild = function(publication, includeTax) {
    var total = 0;
    if (publication.order) {
      angular.forEach(publication.order.items, function(v){
        if (includeTax) {
          total += v.price.soldPrice * v.amount + v.price.soldPrice * v.amount * v.price.tax / 100;
        } else {
          total += v.price.soldPrice * v.amount;
        }
      });
    }

    return total;
  };

  var updateTotalOrderChild =  function(publication) {
    var indexOrder = $scope.children.indexOf(publication);
    $scope.children[indexOrder].totalExcludeTax = totalOrderChild(publication);
    $scope.children[indexOrder].totalIncludeTax = totalOrderChild(publication, true);
    $scope.children[indexOrder].totalTax        = totalOrderChild(publication, true) - totalOrderChild(publication);
  };

  $scope.createNewInterval = function(){
    var publicationSubscription = angular.copy($scope.publication);
    delete publicationSubscription.id;
    delete publicationSubscription.objectNumber;
    publicationSubscription.parent = $scope.publication;
    CompanyPublicationService.save({companyId: $stateParams.companyId}, publicationSubscription, function(resp, headers) {
      var child = resp;
      child.id= headers('Location').split('/').pop();
      
      var data = angular.copy($scope.order);
      data.publication = child;
      delete data.id;
      delete data.items;

      CompanyPublicationCompanyOrderSubcriptionService.update({
        companyId: $stateParams.companyId,
        publicationId: child.id
      }, data).$promise.then(function(order){
        child.features.currentCompanyOrderId = order.id;
        $scope.savePublication(child);
        child.order = order;
        angular.forEach($scope.order.items, function(value){
          $scope.updateCompanyOrderChild(value.product, child);
        });
        $state.reload();
      });
    }, function(error) {
      if (error.status === 400 && error.data.error && error.data.error.code === 1614) {
        growl.addErrorMessage($translate.instant('publication.reached-your-limit'));  
      } else {
        growl.addErrorMessage($translate.instant('publication.create-failure'));
      }
    });
  };

  $scope.addOrderAddress = function(){
    if($scope.newAddress){
      if(!$scope.order.extra.addresses){
        $scope.order.extra.addresses = [];
      }
      if($scope.newAddress.formatted_address){
        $scope.order.extra.addresses.push({name: $scope.newAddress.formatted_address, url: $scope.newAddress.url});
      }else{
        $scope.order.extra.addresses.push({name: $scope.newAddress, url: false});
      }
      $scope.update($scope.order, $scope.publication);
      $scope.newAddress = null;
    }
  };

  $scope.goToMap = function(address){
    window.open(address.url, '_blank');
  };

  var queryOrderStatuses = function() {
    return CompanyService.queryOrderStatuses({
      companyId: $stateParams.companyId
    }).$promise;
  };

  queryOrderStatuses().then(function(resp){
    $scope.orderStatuses = resp;
    $scope.orderStatusesSorted = ($filter('orderBy')($scope.orderStatuses, 'stepNr')).filter(function(v){
      return v.stepNr > 0;
    });
  });

  $scope.$on('showCustomerInfo', function() {
    $scope.showCustomerInfo = true;
  });

  $scope.addProduct = function(product) {
    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
    angular.element('#filterProduct').val('');
    $scope.updateCompanyOrder(product).then(function(resp){
      var index = $scope.order.items.push(resp);
      $scope.order.items[index-1].price = angular.copy(product.pricelist[0]);
      $scope.order.items[index-1].price.soldPrice = $scope.order.items[index-1].price.price;
      $scope.setDefautPricelist($scope.order);
      $scope.showModalEditItem($scope.order.items[index-1], index-1, true);
    }, function(){
      growl.addErrorMessage($translate.instant('order.update-failure'));
    });
  };

  $scope.addProductOrderChild = function(product, publication) {
    $scope.nonProductsAdded.splice($scope.nonProductsAdded.indexOf(product), 1);
    angular.element('#filterProduct').val('');
    $scope.updateCompanyOrderChild(product, publication).then(function(resp){
      var indexOrder = $scope.children.indexOf(publication);
      var index = $scope.children[indexOrder].order.items.push(resp);
      $scope.children[indexOrder].order.items[index-1].price = angular.copy(product.pricelist[0]);
      $scope.children[indexOrder].order.items[index-1].price.soldPrice = $scope.children[indexOrder].order.items[index-1].price.price;
      $scope.showModalEditItem($scope.children[indexOrder].order.items[index-1], index-1, false, $scope.children[indexOrder]);
      updateTotalOrderChild($scope.children[indexOrder]);
    }, function(){
      growl.addErrorMessage($translate.instant('order.update-failure'));
    });
  };

  $scope.setDefautPricelistOrderChild = function(publication) {
    $scope.filterPriceListName();
    if ((publication.order.project && publication.order.project.id) || (publication.order.customer && publication.order.customer.priceList !== null)) {
      angular.forEach(publication.order.items ,function(v){
        if (v.price.priceListId !== $scope.currentProject.id) {
          angular.forEach(v.product.pricelist, function(p){
            if ($scope.currentProject.id === p.priceListId) {
              v.price = angular.copy(p);
              v.price.soldPrice = v.price.price;
              CompanyPublicationCompanyOrderSubcriptionService.updateItem({
                companyId: $stateParams.companyId,
                publicationId: publication.id,
                subcriptionId: publication.order.id,
                itemId: v.id
              }, v);
            }
          });
        }
      });
    }
    updateTotalOrderChild(publication);
  };

  $scope.urlBaseImage = config.apiBase + "/files/";
  $scope.checkImageProduct = function(item) {
    item.product.images = item.product.images.filter(function(item){
      return item.status === true;
    }); 
    if(item.product.images.length > 0){
      item.product.image = config.apiBase + "/files/" + item.product.images[0].id;
    }else{
      item.product.image = "images/no-image.jpg";
    }
    return item;
  };

  $scope.removeProduct = function(index) {
    if($scope.publication.type === 'ORDER_SUBCRIPTION'){
      CompanyPublicationCompanyOrderSubcriptionService.deleteItem({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        subcriptionId: $scope.order.id,
        itemId: $scope.order.items[index].id
      }, function(){
        $scope.order.items.splice(index, 1);
        $scope.updateTotal();
      });
    }else{
      CompanyPublicationCompanyOrderService.deleteItem({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        orderId: $scope.order.id,
        itemId: $scope.order.items[index].id
      }, function(){
        $scope.order.items.splice(index, 1);
        $scope.updateTotal();
      });
    }
  };

  $scope.removeProductOrderChild = function(index, publication) {
    CompanyPublicationCompanyOrderSubcriptionService.deleteItem({
      companyId: $stateParams.companyId,
      publicationId: publication.id,
      subcriptionId: publication.order.id,
      itemId: publication.order.items[index].id
    }, function(){
      $scope.children[$scope.children.indexOf(publication)].order.items.splice(index, 1);
      updateTotalOrderChild(publication);
    });
  };

  $scope.updateNonProductsAdded = function(filter) {
    var p = CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
          return products.filter(function(item) {
            return !$scope.order.items.some(function(i) {
              return item.id === i.product.id;
            });
          });
        }).then(function(nonProducts) {
          if(nonProdcutAddedPromise === p) {
            $scope.nonProductsAdded = nonProducts;
          }
        });
        nonProdcutAddedPromise = p;
  };

  $scope.updateProducts = function(filter) {
    CompanyProductsService.query({companyId: $stateParams.companyId, name: filter, limit: 10}).$promise.then(function(products) {
      if($scope.currentProject){
        nonProdcutAddedPromise = products.filter(function(v){
          return v.pricelist.filter(function(item){
            return $scope.currentProject.id === item.priceListId;
          })[0];
        });
      }else{
        nonProdcutAddedPromise = products;
      }
      $scope.nonProductsAdded = nonProdcutAddedPromise;
    });
  };

  $scope.updateCompanyOrder = function(product) {
    var item = {
      product: product,
      amount: 1,
      price: {
        priceListId: (product.pricelist.length > 0) ? product.pricelist[0].priceListId : null,
        soldPrice: (product.pricelist.length > 0) ? product.pricelist[0].price : 0
      }
    };
    if($scope.publication.type === 'ORDER_SUBCRIPTION'){
      return CompanyPublicationCompanyOrderSubcriptionService.updateItems({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        subcriptionId: $scope.order.id
      }, item).$promise;
    }else{
      return CompanyPublicationCompanyOrderService.updateItems({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        orderId: $scope.order.id
      }, item).$promise;
    }
  };

  $scope.updateCompanyOrderChild = function(product, publication) {
    var item = {
      product: product,
      amount: 1,
      price: {
        priceListId: (product.pricelist.length > 0) ? product.pricelist[0].priceListId : null,
        soldPrice: (product.pricelist.length > 0) ? product.pricelist[0].price : 0
      }
    };
    return CompanyPublicationCompanyOrderSubcriptionService.updateItems({
      companyId: $stateParams.companyId,
      publicationId: publication.id,
      subcriptionId: publication.order.id
    }, item).$promise;
  };

  $scope.addRowText = function(RowTextNew){
    if(!$scope.order.extra.rowText){
      $scope.order.extra.rowText = [];
    }
    $scope.order.extra.rowText.push(RowTextNew);
  };  

  $scope.addRowTextOrderChild = function(RowTextNew, publication){
    var indexOrder = $scope.children.indexOf(publication);
    if(!$scope.children[indexOrder].order.extra.rowText){
      $scope.children[indexOrder].order.extra.rowText = [];
    }
    $scope.children[indexOrder].order.extra.rowText.push(RowTextNew);
  };  

  $scope.createNextOrderChild = function(publication){
    CompanyPublicationCompanyOrderSubcriptionService.createNextOrder({
      companyId: $stateParams.companyId,
      publicationId: publication.id,
      subcriptionId: publication.order.id
    }, {}, function(){
      growl.addSuccessMessage($translate.instant('order.create-next-order-success'));
    }, function(){
      growl.addErrorMessage($translate.instant('order.create-next-order-failure'));
    });
  };

  $scope.showModalEditItem = function(item, index, isMain, publicationChild) {
    $modal({
      scope: $scope,
      controller: 'CompanyPublicationCompanyOrderEditCtrl',
      templateUrl: 'partials/company/publications/company-order/edit.html',
      show: true,
      resolve: {
        item: function() {
          return item || false;
        },
        index: function() {
          return (angular.isUndefined(index) ? -1 : index);
        },
        isMain: function() {
          return isMain;
        },
        publicationChild: function() {
          return publicationChild;
        }
      }
    });
  };

  $scope.updateOrderChild = function(publication) {
    var o = angular.copy(publication.order);
    if(o.customerOrderNr === ''){
      o.customerOrderNr = null;
    }
    if(publication.type === 'ORDER_SUBCRIPTION'){
      o.interval = o.subcriptionNumber + ' ' + o.optionSubcription + (o.subcriptionNumber > 1 ? 's' : '');
    }
    o.$update({
      companyId: $stateParams.companyId,
      publicationId: publication.id
    }, function(){
      growl.addSuccessMessage($translate.instant('order.update-success'));
      var indexOrder = $scope.children.indexOf(publication);
      var subcription            = o.interval.split(' ');
      $scope.children[indexOrder].order.subcriptionNumber   = parseInt(subcription[0]);
      $scope.children[indexOrder].order.optionSubcription   = subcription[1][subcription[1].length-1] === 's' ? subcription[1].substring(0, subcription[1].length-1) : subcription[1];
      if(!$scope.children[indexOrder].order.lastGenAt){
        $scope.children[indexOrder].order.lastGenAt = $scope.children[indexOrder].order.createdAt;
      }
      if(o.startAt >= o.lastGenAt){
        $scope.children[indexOrder].order.nextCreatedOrder = moment($scope.children[indexOrder].order.startAt).add(parseInt($scope.children[indexOrder].order.subcriptionNumber), $scope.children[indexOrder].order.optionSubcription+($scope.children[indexOrder].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
      }else{
        $scope.children[indexOrder].order.nextCreatedOrder = moment($scope.children[indexOrder].order.lastGenAt).add(parseInt($scope.children[indexOrder].order.subcriptionNumber), $scope.children[indexOrder].order.optionSubcription+($scope.children[indexOrder].order.optionSubcription === 'mon' ? 'ths':'s')).format('YYYY-MM-DD');
      }
    }, function(){
      growl.addErrorMessage($translate.instant('order.update-failure'));
    });
  };

  $scope.nextStatus = function() {
    if ($scope.orderStatusesSorted.length === 0) {
      return;
    }
    if (!$scope.order.orderStatus) {
      $scope.order.orderStatus = $scope.orderStatusesSorted[0].id;
      $scope.update($scope.order, $scope.publication);
    } else {
      var index = $scope.orderStatusesSorted.findIndex(function(v){
        return v.id === $scope.order.orderStatus;
      });

      if (index >= ($scope.orderStatusesSorted.length - 1) || index < 0) {
        return;
      }

      $scope.order.orderStatus = $scope.orderStatusesSorted[index + 1].id;
      $scope.update($scope.order, $scope.publication);
    }
  };

  $scope.showApproveDocModal = function() {
    var modalApprove = $modal({
      scope: $scope,
      controller: ['$scope', function($scope){
        $scope.approvedSign = {
          comment: '',
          sign: ''
        };
      }],
      templateUrl: 'partials/company/publications/detail/approve-doc.html',
      show: false
    });
    modalApprove.$promise.then(modalApprove.show);
  };

  $scope.submitOrder = function(createQuote, createOrder, approveOrder, approvedSign) {
    var orderDeferred = $q.defer();
    var sendEmail = false;
    var emailTo = $scope.order.customer.invoiceEmailTo;
    if($scope.order.customer.sendInvoiceEmail && !createQuote && !createOrder && !approveOrder){
       $modal({
        scope: $scope,
        controller: ['$scope', function($scope){
          $scope.sendEmail = false;
          $scope.emailTo = $scope.order.customer.invoiceEmailTo;
          $scope.sendInvoiceEmail = function(){
            sendEmail = $scope.sendEmail;
            emailTo   = $scope.emailTo;
            orderDeferred.resolve();
          };
        }],
        templateUrl: 'partials/company/publications/company-order/send-mail-modal.html',
        show: true
      });
    }else{
      if(approveOrder && approvedSign){
        $scope.order.extra.approvedSign = approvedSign;
      }
      orderDeferred.resolve();
    }
    orderDeferred.promise.then(function(){
      if(!createQuote && !createOrder && !approveOrder){
        $scope.order.status = 'ACTIVE';
        $scope.order.submitedAt = new Date();
      }
      $scope.order.$update({
        companyId: $stateParams.companyId,
        publicationId: $stateParams.publicationId,
        createQuote: (createQuote ? createQuote : null),
        createOrder: (createOrder ? createOrder: null),
        approved: (approveOrder ? true : null),
        sendEmail: (($scope.order.customer.sendInvoiceEmail && !createQuote && !createOrder && !approveOrder) ? sendEmail: null),
        emailTo: (($scope.order.customer.sendInvoiceEmail && !createQuote && !createOrder && !approveOrder) ? emailTo : null)
      }, function(publication){
        growl.addSuccessMessage($translate.instant('order.submit-success'));
        if(!createQuote && !createOrder && !approveOrder){
          window.location.href = '/order/'+$stateParams.companyId+'/detail/'+publication.id;
        }else{
          CompanyPublicationCompanyOrderService.get({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId,
            orderId: $scope.order.id
          }).$promise.then(function(resp){
            $scope.order = resp;
          });
        }
      }, function(){
        if(!createQuote && !createOrder && !approveOrder){
          $scope.order.status = 'CART';
        }
        growl.addErrorMessage($translate.instant('order.order-failure'));
      });
    });
  };

  $scope.productPreview = function(product) {
    jQuery.fancybox.open([{
      type: 'image',
      padding: 0,
      margin: 0,
      href: product ? config.apiBase + '/files/' + product.id : ''
    }]);
    return false;
  };
}

angular.module('dokiv')
  .controller('CompanyPublicationCompanyOrderCtrl', ['$scope',
    '$state',
    '$stateParams',
    '$translate',
    'config',
    '$q',
    '$http',
    '$modal',
    '$filter',
    'growl',
    'CompanyProductsService',
    'CompanyCustomersService',
    'CompanyPublicationService',
    'CompanyPublicationCompanyOrderService',
    'CompanyPublicationCompanyOrderSubcriptionService',
    'CompanyService',
    CompanyPublicationCompanyOrderCtrl]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/companyOrder/CompanyPublicationCompanyOrderCtrl.js
// module id = 396
// module chunks = 0